export const MIN_OCTAVE = -1;
export const MAX_OCTAVE = 8;
